import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9013b66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "banner" }
const _hoisted_2 = { class: "product-title" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" PM")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "2.5", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" PM")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "10", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 遥感反演图 ")
const _hoisted_10 = { class: "pm-select" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" PM")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "2.5", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" PM")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "10", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "legend" }
const _hoisted_18 = { class: "pm25legend" }
const _hoisted_19 = { class: "pm10legend" }
const _hoisted_20 = { class: "product-select-img" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "环境监测点", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "遥感反演图", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "卫星云图", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "夜间灯光指数", -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]

import {
  computed, onMounted, onUnmounted, ref, watch,
} from 'vue';
import qs from 'qs';
import moment from 'moment';
import { useStore, } from 'vuex';
import AirQualityStatus from '../airQualityStatus/index.vue';
import OLMapContainer from '@/pages/index/components/indexMap/index.vue';
import allRegion from '@/configs/allRegion';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
// 选择的产品类型
const selectType = ref('0');
//  PM2.5类型
const pmType = ref('PM25');
// 当前城市定位
const currentLoaction = computed(() => store.state.OLMap.location);
const regionId = computed(() => store.state.OLMap.regionId) || 320100000000;
const cityId = computed(() => store.state.OLMap.cityId);

// 实时影像数据
const realtimeDatas = computed(() => store.state.gateway.realtimeDatas);
// PM产品数据
const pmDatas = computed(() => store.state.gateway.pmDatas);
// 夜间灯管数据
const eveLightDatas = computed(() => store.state.gateway.eveLightDatas);

const handlerClick = (value: any) => {
  if (regionId.value) {
    const params = { regionId: regionId.value, };
    const params2 = qs.stringify({ regionId: regionId.value, });

    if (value === '0') {
      store.dispatch('gateway/getAirQualityMap', params2);

      const mapParams = {
        indexName: 'AQI',
        type: 1,
        queryType: 0,
      };

      store.dispatch('gateway/getHistoryData', mapParams);
    } else if (value === '1') {
      const pmParams = {
        type: pmType.value,
        regionId: regionId.value,
      };

      store.dispatch('gateway/getAirIssuePath', pmParams);
    } else if (value === '2') {
      store.dispatch('gateway/getAirMetePath', params);
    } else if (value === '3') {
      store.dispatch('gateway/getAirEveLights', params2);
    }
    store.commit('gateway/setStateItem', {
      type: 'selectType',
      value,
    });
    selectType.value = value;
  }
};

watch(pmType, (cur) => {
  const pmParams = {
    type: cur,
    regionId: regionId.value,
  };

  store.dispatch('gateway/getAirIssuePath', pmParams);
});

watch(currentLoaction, (cur) => {
  if (Object.keys(cur).length) {
    const { location, } = cur;
    const { city, province, } = location;
    const temp: any = allRegion
      .find((item: any) => item.name === province)?.children
      .find((item) => item.name === city);
    const pos = {
      location,
      position: {
        lng: temp.lon,
        lat: temp.lat,
      },
      regionId: temp.id,
    };

    store.dispatch('OLMap/getRegionId', pos);
    store.commit('OLMap/setStateItem',{
      value: temp.id,
      type: 'cityId',
    });
  }
});
watch(regionId, (cur) => {
  if (cur) {
    const params = qs.stringify({ regionId: cur, });

    store.dispatch('gateway/getAirQualityMap', params);
    const mapParams = {
      indexName: 'AQI',
      type: 1,
      queryType: 0,
    };

    store.dispatch('gateway/getHistoryData', mapParams);
  }
});

watch(cityId, (cur) => {
  if (cur) {
    const params = qs.stringify({ regionId: cur, });

    store.dispatch('OLMap/getExtentData', params);
  }
});

onMounted(() => {
  if (regionId.value) {
    const params = qs.stringify({ regionId: regionId.value, });

    store.dispatch('gateway/getAirQualityMap', params);
    const mapParams = {
      indexName: 'AQI',
      type: 1,
      queryType: 0,
    };

    store.dispatch('gateway/getHistoryData', mapParams);
  }

  if (cityId.value) {
    const paramsExtent = qs.stringify({ regionId: cityId.value, });

    store.dispatch('OLMap/getExtentData', paramsExtent);
  }
});

onUnmounted(() => {
  store.commit('gateway/setStateItem', {
    type: 'selectType',
    value: '0',
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(OLMapContainer),
    _withDirectives(_createVNode(AirQualityStatus, null, null, 512), [
      [_vShow, selectType.value === '0']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(`${
        Object.keys(_unref(pmDatas)).length ?
        _unref(moment)(_unref(pmDatas)?.btTime, 'YYYYMMDDHHmm').format('YYYY/MM/DD'):
        '-'
        }`) + " " + _toDisplayString(_unref(currentLoaction)?.location?.city) + " ", 1),
      _withDirectives(_createElementVNode("span", null, _hoisted_5, 512), [
        [_vShow, pmType.value==='PM25']
      ]),
      _withDirectives(_createElementVNode("span", null, _hoisted_8, 512), [
        [_vShow, pmType.value==='PM10']
      ]),
      _hoisted_9
    ], 512), [
      [_vShow, selectType.value === '1']
    ]),
    _withDirectives(_createElementVNode("div", { class: "product-title" }, _toDisplayString(`${
        Object.keys(_unref(realtimeDatas)).length ?
        _unref(moment)(_unref(realtimeDatas)?.btTime, 'YYYYMMDDHHmm').format('YYYY/MM/DD'):
        '-'
        }`) + " " + _toDisplayString(_unref(currentLoaction)?.location?.city) + " 卫星云图 ", 513), [
      [_vShow, selectType.value === '2']
    ]),
    _withDirectives(_createElementVNode("div", { class: "product-title" }, _toDisplayString(`${
        Object.keys(_unref(eveLightDatas)).length ?
        _unref(moment)(_unref(eveLightDatas)?.btTime, 'YYYYMMDDHHmm').format('YYYY/MM/DD'):
        '-'
        }`) + " " + _toDisplayString(_unref(currentLoaction)?.location?.city) + " 夜间灯光指数图 ", 513), [
      [_vShow, selectType.value === '3']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: _normalizeClass(['btn-pm25', pmType.value === 'PM25' ? 'active' : '']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (pmType.value = 'PM25'))
      }, _hoisted_13, 2),
      _createElementVNode("button", {
        class: _normalizeClass(['btn-pm10', pmType.value === 'PM10' ? 'active' : '']),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (pmType.value = 'PM10'))
      }, _hoisted_16, 2)
    ], 512), [
      [_vShow, selectType.value === '1']
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "aqi-map",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/mapNotLogin/threeDimensional')))
    }, null, 512), [
      [_vShow, selectType.value === '0']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_17, null, 512), [
      [_vShow, selectType.value === '0']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_18, null, 512), [
      [_vShow, selectType.value === '1' && pmType.value === 'PM25']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_19, null, 512), [
      [_vShow, selectType.value === '1' && pmType.value === 'PM10']
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("button", {
        class: _normalizeClass(["btn-product environment", { active: selectType.value === '0'}]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (handlerClick('0')))
      }, _hoisted_23, 2),
      _createElementVNode("button", {
        class: _normalizeClass(["btn-product pm", { active: selectType.value === '1'}]),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (handlerClick('1')))
      }, _hoisted_26, 2),
      _createElementVNode("button", {
        class: _normalizeClass(["btn-product realimg", { active: selectType.value === '2'}]),
        onClick: _cache[5] || (_cache[5] = ($event: any) => (handlerClick('2')))
      }, _hoisted_29, 2),
      _createElementVNode("button", {
        class: _normalizeClass(["btn-product even-light", { active: selectType.value === '3'}]),
        onClick: _cache[6] || (_cache[6] = ($event: any) => (handlerClick('3')))
      }, _hoisted_32, 2)
    ])
  ]))
}
}

})